import request from '@/lib/request';
import { initColumns } from '@/lib/utils';

export async function getLabelRelationByParent(options) {
  const { parentId = '', instrumentType, coursewareId } = options || {};
  const params = {
    coursewareId,
    must: [
      {
        term: {
          'parentId.keyword': parentId
        }
      }
    ]
  };
  if (instrumentType) {
    params.must.push({
      term: {
        'groups.keyword': instrumentType
      }
    });
  }
  const result = await request.post('/nlp/case/get/label/relation/data', params);
  return initColumns(result.hits.hits);
}

export async function getLabelRelationByCustom(params) {
  const result = await request.post('/nlp/case/get/label/relation/data', params);
  return initColumns(result.hits.hits);
}

export async function getCalculatorFunction() {
  const result = await request.post('/nlp/calculator/function', {});
  return result.hits.hits;
}

export function testCalculator(params) {
  return request.post('/nlp/test/simple/calculation', params);
}

export async function getParagraphCourseFilter() {
  const result = await request.post('/nlp/case/get/label/relation/data/paragraph', { byFilter: true });
  return result.hits.map(item => ({
    key: item._source.field_name,
    value: item._source.chinese_name,
    parentId: item._source.parentId,
    levelId: item._source.levelId,
    groups: item._source.groups
  }));
}

export const getParagraph = (function() {
  let requestPromise = null;
  let preCourseId = '';
  return async function(courseId = '') {
    try {
      if (preCourseId !== courseId) {
        preCourseId = courseId;
        requestPromise = null;
      }
      if (!requestPromise) {
        const params = {};
        if (preCourseId) {
          params.courseId = preCourseId;
        }
        requestPromise = request.post('/nlp/case/get/label/relation/data/paragraph', params);
      }
      const result = await requestPromise;
      return result.hits.map(item => ({
        key: item._source.field_name,
        value: item._source.chinese_name,
        parentId: item._source.parentId,
        levelId: item._source.levelId,
        groups: item._source.groups
      }));
    } catch (err) {
      requestPromise = null;
      throw Error(err);
    }
  };
})();

// 获取案件列表
export function getRelation(params) {
  return request.post(`/nlp/case/relation`, params);
}

export function updRelationSort(arr) {
  return request.post('/nlp/label/relation/sort', arr);
}

//查询研究点可筛选标签
export function getRelationChart(params) {
  return request.post('/nlp/case/get/label/relation/chart', params);
}

export function getEntityRelationGroup() {
  const result = getEntityRelation();
  return [
    {
      label: '文本',
      key: 'text_group',
      children: result.text_entity
    },
    {
      label: '数值',
      key: 'num_group',
      children: result.num_entity
    },
    {
      label: '日期',
      key: 'date_group',
      children: result.date_entity
    }
  ];
}

export function getEntityRelation() {
  return {
    text_entity: [
      {
        label: '一般标签',
        type: 'text',
        tip: '当标签的值是是或否时，请选择标签（如：自首）'
      },
      {
        label: '分类标签',
        type: 'text_dict',
        tip: '当标签的值是有可以穷尽的分类时，请选择分类标签（如：性别）'
      },
      {
        label: '主体标签（自然人）',
        type: 'text_entity_ner',
        tip: '当标签的变量的值是人名时，请选择主体标签（自然人）（如：被告人姓名）'
      },
      {
        label: '主体标签（自然人+非自然人）',
        type: 'text_entity_natural_person',
        tip:
          '当标签的变量的值同时包含人名和单位/企业/机构名称时，请选择主体标签（自然人+非自然人）（如：民事原告，既有自然人，李某一，又有非自然人，xxx有限公司）'
      },
      {
        label: '主体标签（非自然人）',
        type: 'text_entity_natural_company',
        tip:
          '当标签的变量的值是单位/企业/机构名称时，请选择主体标签（非自然人）（如：xxx有限公司）'
      },
      {
        label: '地址标签',
        type: 'text_entity_loc',
        tip: '当标签的变量的值是地址时，请选择抽取地址标签（如：注册地址）'
      },
      {
        label: '编号标签',
        type: 'text_entity_index',
        tip: '当标签的变量的值是连续的字母、符号、数字及其组合时，请选择编号标签（如：统一社会信用代码、身份证号码）'
      }
    ],
    num_entity: [
      {
        label: '数量标签',
        type: 'num',
        tip: '当标签的变量的值是阿拉伯数字的时，请选择一般数值（如：年龄）'
      },
      { label: '金额标签', type: 'num_entity_amount', tip: '当标签的变量的值是金额的，请选择金额（如：盗窃金额）' },
      {
        label: '毒品克数',
        type: 'num_entity_drug',
        tip: '当标签的变量的值是毒品重量的，请选择毒品克数（如：海洛因克数）'
      },
      {
        label: '时长标签',
        type: 'num_entity_time',
        tip: '当标签的变量的值是按照时间长短计数时，请选择时长（如：刑期）'
      }
    ],
    date_entity: [
      {
        label: '日期标签',
        type: 'date',
        tip: '当标签的变量的值是日期时，请选择日期（如：文书日期）'
      }
    ]
  };
}

export function getRelationFilter(courseId, entityIds) {
  return request.post('/nlp/case/relation/filter', {
    coursewareId: courseId,
    entityIds
  });
}

export function fieldChangeMove(params) {
  return request.post('/nlp/analysis/label/change/core', params);
}
